"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _EmailMediator = require("customer-data-email/schema/email/EmailMediator");

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _CurrentTeamsContainer = _interopRequireDefault(require("crm_internal/containers/CurrentTeamsContainer"));

var createInteractionRecord = function createInteractionRecord(_ref) {
  var html = _ref.html,
      type = _ref.type;

  var ownerId = _CurrentOwnerContainer.default.get();

  var teamId = _CurrentTeamsContainer.default.getMyTeam();

  var interactionRecord = new _InteractionRecord.default((0, _immutable.fromJS)({
    metadata: {
      body: html
    },
    associations: {
      ownerIds: (0, _immutable.Set)()
    }
  }));
  return (0, _Interactions.initInteractionRecord)(interactionRecord, type, ownerId, teamId);
};

var _default = function _default(_ref2) {
  var objectType = _ref2.objectType,
      subject = _ref2.subject,
      html = _ref2.html,
      selectedDisposition = _ref2.selectedDisposition,
      selectedActivityType = _ref2.selectedActivityType,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? _EngagementTypes.NOTE : _ref2$type;
  var timestamp = Date.now();
  var interactionRecord = createInteractionRecord({
    html: html,
    type: type
  }).setEngagementType(type).setIn(['engagement', 'timestamp'], timestamp);

  if (selectedActivityType) {
    interactionRecord = interactionRecord.setIn(['engagement', 'activityType'], selectedActivityType);
  }

  if (type === _EngagementTypes.EMAIL) {
    var _interactionRecord = interactionRecord,
        metadata = _interactionRecord.metadata;

    if (objectType === _ObjectTypes.CONTACT) {
      var recipientRecord = (0, _EmailMediator.createContactRecipientRecord)(subject);
      metadata = metadata.set('to', (0, _immutable.List)([recipientRecord.to]));
    }

    metadata = metadata.set('html', html).delete('body');
    interactionRecord = interactionRecord.set('metadata', metadata);
  }

  if (type === _EngagementTypes.MEETING) {
    var _metadata = interactionRecord.metadata;
    _metadata = _metadata.set('startTime', timestamp).set('endTime', timestamp);
    interactionRecord = interactionRecord.set('metadata', _metadata);
  }

  if (type === _EngagementTypes.CALL) {
    var _metadata2 = interactionRecord.metadata;
    _metadata2 = _metadata2.set('disposition', selectedDisposition);
    interactionRecord = interactionRecord.set('metadata', _metadata2);
  }

  return interactionRecord;
};

exports.default = _default;
module.exports = exports.default;